import { render, staticRenderFns } from "./ToggleAndMobileButtons.vue?vue&type=template&id=050ffede&scoped=true&"
import script from "./ToggleAndMobileButtons.vue?vue&type=script&lang=js&"
export * from "./ToggleAndMobileButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToggleAndMobileButtons.vue?vue&type=style&index=0&id=050ffede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ffede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})
